var exports = {
  "uW": "xe533113f--c2f2c0--section",
  "Qs": "xe533113f--c2f2c0--content",
  "Mm": "xe533113f--c2f2c0--bounded",
  "DD": "xe533113f--c2f2c0--title",
  "VA": "xe533113f--c2f2c0--subtitle",
};

module.exports = exports;
